// extracted by mini-css-extract-plugin
export default {"root":"SafeHtml_root__bgu83"};